import { LoadingButton } from '@mui/lab';
import { DialogActions, DialogContent, DialogTitle, Button, Dialog, Stack, TextField, Divider, Typography } from '@mui/material';
import { API } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';

export default function ConnectAccountDialog({ open = false, setOpen = () => { } }) {
    const { user, updateUser } = useAuthContext();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState();
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState();
    const [loading, setLoading] = useState(false);
    const [noAccountPassword, setNoAccountPassword] = useState(false);
    const [useLastName, setUseLastName] = useState(false);
    const [lastName, setLastName] = useState('');
    const [lastNameError, setLastNameError] = useState();

    useEffect(() => {
        setNoAccountPassword(user?.provider?.noAccountPassword || false)
        setUseLastName(user?.provider?.useLastName || false)
    }, [user]);

    const handleConnectAccount = () => {
        if (username && (password || noAccountPassword)) {
            setLoading(true)
            API.post('fgnapi', '/partner/connect', {
                body: {
                    accountUsername: username,
                    accountPassword: password,
                    accountLastName: lastName
                }
            }).then(response => {
                console.log(response)
                if (response.accountUsername) {
                    updateUser({
                        ...user,
                        accountNumber: response.accountUsername,
                        packages: response.plans ? JSON.stringify(response.plans) : null
                    })
                    enqueueSnackbar('Account connected!', { variant: 'success', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } })
                    setLoading(false)
                    setOpen(false)
                    setUsername('')
                    setPassword('')
                    console.log(user)
                } else if (!response.match) {
                    setUsernameError(true);
                    setPasswordError(true);
                    enqueueSnackbar(`Invalid account number${noAccountPassword ? '!' : useLastName ? ' or last name!' : ' or password!'}`, { variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } })
                    setLoading(false)
                } else {
                    enqueueSnackbar('Oops! Something went wrong.', { variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } })
                    setLoading(false)
                }

            }).catch(error => {
                console.log(error)
                enqueueSnackbar('Oops! Something went wrong.', { variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } })
                setLoading(false)
            })
        } else {
            setUsernameError(Boolean(!username))
            setPasswordError(Boolean((!password || noAccountPassword)))
            setLastNameError(Boolean(!lastName))
        }
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='sm'
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                Connect Your Account
                <Typography fontSize={12}>
                    Enter your credentials for {user?.provider?.name}
                </Typography>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Stack spacing={3} mt={3}>
                    <TextField
                        label='Account Number'
                        value={username}
                        required
                        error={usernameError}
                        onChange={(event) => {
                            setUsername(event.target.value)
                            setPasswordError(false)
                            setUsernameError(false)
                        }}
                    />
                    {!noAccountPassword &&
                        <TextField
                            label='Password'
                            value={password}
                            required
                            error={passwordError}
                            onChange={(event) => {
                                setPassword(event.target.value)
                                setPasswordError(false)
                                setUsernameError(false)
                            }}
                            type='password'
                        />
                    }
                    {useLastName &&
                        <TextField
                            label='Last Name On Account'
                            value={lastName}
                            required
                            error={lastNameError}
                            onChange={(event) => {
                                setLastName(event.target.value)
                                setLastNameError(false)
                                setUsernameError(false)
                            }}
                        />
                    }
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        setOpen(false)
                    }}
                    color='error'
                    variant='contained'
                    disabled={loading}
                >
                    Cancel
                </Button>
                <LoadingButton
                    onClick={handleConnectAccount}
                    color='success'
                    variant='contained'
                    loading={loading}
                >
                    Connect Account
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}

ConnectAccountDialog.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func
}